import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { fmtDateTime } from '../../lib/when';

/**
 * A device's power history (116; agent 0.5.6), on its Device tab, for
 * whoever looks after it: start-ups, shutdowns and restarts (with Windows'
 * reason), unexpected shutdowns and blue screens, and the last 30 nights.
 * The machine's history - no names on it. Draws nothing before the
 * migration, for somebody without write, or while the agent has sent none.
 */
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const WORD = {
  startup: ['Started', 'idle'],
  shutdown: ['Shut down', 'idle'],
  restart: ['Restarted', 'info'],
  unexpected_shutdown: ['Unexpected shutdown', 'warning'],
  crash: ['Blue screen', 'danger']
};

export default function DevicePower({ assetId }) {
  const [data, setData] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => {
    axios.get(`${API_BASE}/assets/${assetId}/power`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [assetId]);
  if (!data?.ready || (!data.events.length && !data.nights.length)) return null;
  const c = data.counts;
  const shown = all ? data.events : data.events.slice(0, 10);
  return (
    <section className="as-panel" data-testid="device-power" style={{ marginBottom: '1rem' }}>
      <h2>Power history</h2>
      <p className="as-quiet">
        {`Last ${c.days} days: ${c.crash} blue screen${c.crash === 1 ? '' : 's'}, ${c.unexpected_shutdown} unexpected shutdown${c.unexpected_shutdown === 1 ? '' : 's'}, ${c.restart} restart${c.restart === 1 ? '' : 's'}`}
        {c.nights > 0 && ` · left on ${c.awake_nights} of the last ${c.nights} nights`}
        {'. From Windows’ own log; kept 12 months.'}
      </p>
      <ul className="as-history">
        {shown.map((e, i) => (
          <li key={`${e.kind}-${e.at}-${i}`}>
            <span className="as-chip" data-tone={WORD[e.kind]?.[1] || 'idle'}>{WORD[e.kind]?.[0] || e.kind}</span>
            {e.reason && <span className="as-quiet">{` ${e.reason}`}</span>}
            <span className="as-when">{fmtDateTime(e.at)}</span>
          </li>
        ))}
      </ul>
      {data.events.length > 10 && (
        <button type="button" className="btn btn-plain btn-small" onClick={() => setAll((v) => !v)}>
          {all ? 'Show fewer' : `Show all ${data.events.length}`}
        </button>
      )}
    </section>
  );
}
